export default "__VITE_ASSET__Cp7I9XiL__"